import React from 'react';
import {useTranslate} from '../../../hooks';
import {
  Button,
  DialogActions,
  DialogContent,
  Divider,
  Stack,
  Typography,
} from '@mui/material';
import {IconBadge} from '../../../components';
import {FlexOfferDialogRoutes} from './FlexOfferDialog';
import {
  formatDate,
  useCountry,
  useFlexTransactions,
} from '@resurs-internal/rb-app-api';
import {BaseList} from '@resurs-internal/mui';

export const FlexOfferDialogSuccess: React.FC<{
  navigate: (key: FlexOfferDialogRoutes) => void;
}> = ({navigate}) => {
  const country = useCountry();
  const translate = useTranslate();
  const flex = useFlexTransactions('flex');

  const activated = flex.query.data?.filter((e) => e.markedAsDownPayment);
  const isFlexActivated = Boolean(flex.sum?.amount);
  return (
    <>
      <DialogContent>
        <Stack spacing={2} alignItems={'center'}>
          <IconBadge type={'font'} icon={'check-circle'} size={'xl'} />
          <Typography variant={'h3'} textAlign={'center'}>
            {isFlexActivated
              ? translate('flex.offer.success.subtitle')
              : translate('flex.offer.success.empty.subtitle')}
          </Typography>
          <Typography typography={'body1'}>
            {isFlexActivated
              ? translate('flex.offer.success.description')
              : translate('flex.offer.success.empty.description')}
          </Typography>
          <BaseList
            sx={{
              width: '100%',
              display: isFlexActivated ? undefined : 'none',
            }}
            items={[
              ...(activated?.map((e) => ({
                id: e.id,
                title: e.merchantName ?? '',
                subtitle: formatDate(e.transactionDate),
                endAdornment: (
                  <Typography typography={'subtitle1'}>
                    {country.formatAmount(e.amount)}
                  </Typography>
                ),
              })) ?? []),
              {
                id: 'total',
                title: translate('flex.offer.success.total'),
                hidden: !flex.sum?.amount,
                endAdornment: (
                  <Typography typography={'h4'}>
                    {country.formatAmount(flex.sum)}
                  </Typography>
                ),
              },
            ]}
          />
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button
          color={'secondary'}
          variant={'text'}
          onClick={() => navigate('update')}>
          {translate('common.back')}
        </Button>
        <Button
          color={'primary'}
          variant={'text'}
          onClick={() => navigate('close')}>
          {translate('common.close')}
        </Button>
      </DialogActions>
    </>
  );
};
